// Reports: pick a report, choose the date range, view, print or export as CSV.
import React, { useEffect, useState } from 'react';
import { api } from '../api';
import { Spinner, ErrorBox, DateField } from '../ui';
import { todayDarwin, addMonths, csvDownload } from '../util';

export default function Reports() {
  const [list, setList] = useState<{ key: string; title: string }[]>([]);
  const [selected, setSelected] = useState('daily_onsite');
  const [from, setFrom] = useState(todayDarwin());
  const [to, setTo] = useState(addMonths(todayDarwin(), 3));
  const [report, setReport] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => { api('/reports').then(setList).catch(e => setError(e.message)); }, []);

  const run = () => {
    setLoading(true);
    setError(null);
    api(`/reports/${selected}?from=${from}&to=${to}`)
      .then(setReport)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  };
  useEffect(run, [selected]);

  return (
    <div className="page">
      <div className="page-head no-print">
        <h2>Reports</h2>
        <div className="btn-row">
          <select className="input" value={selected} onChange={e => setSelected(e.target.value)}>
            {list.map(r => <option key={r.key} value={r.key}>{r.title}</option>)}
          </select>
          <span className="muted">From</span><div style={{ width: 130 }}><DateField value={from} onChange={v => v && setFrom(v)} /></div>
          <span className="muted">to</span><div style={{ width: 130 }}><DateField value={to} onChange={v => v && setTo(v)} /></div>
          <button className="btn btn-primary" onClick={run}>Run</button>
          <button className="btn" onClick={() => window.print()}>Print / PDF</button>
          <button className="btn" disabled={!report}
            onClick={() => report && csvDownload(`${selected}.csv`, report.columns, report.rows)}>Export CSV</button>
        </div>
      </div>
      <ErrorBox error={error} onDismiss={() => setError(null)} />
      {loading && <Spinner label="Running report…" />}
      {report && !loading && (
        <div className="table-wrap">
          <div style={{ padding: '10px 12px', borderBottom: '1px solid var(--border)' }}>
            <h3 style={{ margin: 0 }}>{report.title}</h3>
            <span className="muted">{report.rows.length} row(s)</span>
          </div>
          <div className="table-scroll">
            <table>
              <thead><tr>{report.columns.map((c: string) => <th key={c}>{c}</th>)}</tr></thead>
              <tbody>
                {report.rows.length === 0 && <tr><td colSpan={report.columns.length} className="muted" style={{ padding: 20 }}>No data for this period.</td></tr>}
                {report.rows.map((r: any[], i: number) => (
                  <tr key={i}>{r.map((v, j) => <td key={j}>{String(v ?? '')}</td>)}</tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
